import createApi from '@/services/Api';

function Call() {
  const api = createApi();

  function refuse(callId) {
    const endpoint = `/profissional-saude/chamada/recusar`;
    return api.post(endpoint, {
      chamadaId: callId,
      motivo: 'Estou indisponível no momento.',
    });
  }

  function accept(callId) {
    const endpoint = `/profissional-saude/chamada/aceitar/${callId}`;
    return api.post(endpoint);
  }

  return { refuse, accept };
}

export default Call();
